import { MYKBB_EVENT_FEATURE, myKbbMenuClick, myKbbMenuImpression } from './mykbbMenuEvents';
import { psxAnalyticsEvent } from './psxPageEvents';
export function handleEventBusEvent(_ref, data, getDataLayer, options) {
  let {
    history
  } = _ref;
  const {
    customData
  } = data;
  const dataLayer = getDataLayer();
  if (customData?.appKey === 'psx-listing-actions' || customData?.appKey === 'psx') {
    psxAnalyticsEvent({
      data,
      dataLayer
    }, options);
  } else if (data?.eventElement === MYKBB_EVENT_FEATURE) {
    if (data.eventAction === 'click') {
      myKbbMenuClick({
        pixallData: data.pixall,
        eventLabel: data.eventResult
      }, dataLayer);
    } else {
      myKbbMenuImpression({
        pixallData: data.pixall,
        eventLabel: data.eventResult
      }, dataLayer);
    }
  }
}
export default {
  handleEventBusEvent
};